/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetJobLogByExecutionIdParams,
  GetLogParams,
  GetLogsByExecutionIdParams,
  JobLogDto,
  JobLogDtoPagination,
  LogDto,
  LogDtoPagination,
  LogTableRequest,
  PaginatedJobLogsRequest
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetPaginatedLogsUrl = () => {




  return `/api/Log/GetPaginatedLogs`
}

export const getPaginatedLogs = async (logTableRequest?: LogTableRequest, options?: Parameters<typeof customInstance>[1]): Promise<LogDtoPagination> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<LogDtoPagination>(getGetPaginatedLogsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(logTableRequest)
  }
);}





export const getGetPaginatedLogsMutationKey = () => ['getPaginatedLogs'] as const;

export const getGetPaginatedLogsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedLogs>>, TError,GetPaginatedLogsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getPaginatedLogs>>, TError,GetPaginatedLogsMutationVariables, TContext> => {

const mutationKey = getGetPaginatedLogsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPaginatedLogs>>, GetPaginatedLogsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  getPaginatedLogs(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPaginatedLogsMutationResult = NonNullable<Awaited<ReturnType<typeof getPaginatedLogs>>>
    export type GetPaginatedLogsMutationBody = BodyType<LogTableRequest> | undefined
    export type GetPaginatedLogsMutationError = ErrorType<unknown>
    export type GetPaginatedLogsMutationVariables = {data?: BodyType<LogTableRequest>}

    export const useGetPaginatedLogs = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedLogs>>, TError,GetPaginatedLogsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPaginatedLogs>>,
        TError,
        GetPaginatedLogsMutationVariables,
        TContext
      > => {
      return useMutation(getGetPaginatedLogsMutationOptions(options), queryClient);
    }
    export const getGetLogUrl = (params?: GetLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Log/GetLog?${stringifiedParams}` : `/api/Log/GetLog`
}

export const getLog = async (params?: GetLogParams, options?: Parameters<typeof customInstance>[1]): Promise<LogDto> => {

  return customInstance<LogDto>(getGetLogUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLogQueryKey = (params?: GetLogParams,) => {
    return [
    `/api/Log/GetLog`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLogQueryOptions = <TData = Awaited<ReturnType<typeof getLog>>, TError = ErrorType<unknown>>(params?: GetLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLogQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLog>>> = ({ signal }) => getLog(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLogQueryResult = NonNullable<Awaited<ReturnType<typeof getLog>>>
export type GetLogQueryError = ErrorType<unknown>


export function useGetLog<TData = Awaited<ReturnType<typeof getLog>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLogParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLog>>,
          TError,
          Awaited<ReturnType<typeof getLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLog<TData = Awaited<ReturnType<typeof getLog>>, TError = ErrorType<unknown>>(
 params?: GetLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLog>>,
          TError,
          Awaited<ReturnType<typeof getLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLog<TData = Awaited<ReturnType<typeof getLog>>, TError = ErrorType<unknown>>(
 params?: GetLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLog<TData = Awaited<ReturnType<typeof getLog>>, TError = ErrorType<unknown>>(
 params?: GetLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLogQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetLogSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getLog>>, TError = ErrorType<unknown>>(params?: GetLogParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLogQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLog>>> = ({ signal }) => getLog(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetLogSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLog>>>
export type GetLogSuspenseQueryError = ErrorType<unknown>


export function useGetLogSuspense<TData = Awaited<ReturnType<typeof getLog>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLogParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLogSuspense<TData = Awaited<ReturnType<typeof getLog>>, TError = ErrorType<unknown>>(
 params?: GetLogParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLogSuspense<TData = Awaited<ReturnType<typeof getLog>>, TError = ErrorType<unknown>>(
 params?: GetLogParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLogSuspense<TData = Awaited<ReturnType<typeof getLog>>, TError = ErrorType<unknown>>(
 params?: GetLogParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLogSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPaginatedJobLogsUrl = () => {




  return `/api/Log/GetPaginatedJobLogs`
}

export const getPaginatedJobLogs = async (paginatedJobLogsRequest: PaginatedJobLogsRequest, options?: Parameters<typeof customInstance>[1]): Promise<JobLogDtoPagination> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<JobLogDtoPagination>(getGetPaginatedJobLogsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(paginatedJobLogsRequest)
  }
);}





export const getGetPaginatedJobLogsMutationKey = () => ['getPaginatedJobLogs'] as const;

export const getGetPaginatedJobLogsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedJobLogs>>, TError,GetPaginatedJobLogsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getPaginatedJobLogs>>, TError,GetPaginatedJobLogsMutationVariables, TContext> => {

const mutationKey = getGetPaginatedJobLogsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPaginatedJobLogs>>, GetPaginatedJobLogsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  getPaginatedJobLogs(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPaginatedJobLogsMutationResult = NonNullable<Awaited<ReturnType<typeof getPaginatedJobLogs>>>
    export type GetPaginatedJobLogsMutationBody = BodyType<PaginatedJobLogsRequest>
    export type GetPaginatedJobLogsMutationError = ErrorType<unknown>
    export type GetPaginatedJobLogsMutationVariables = {data: BodyType<PaginatedJobLogsRequest>}

    export const useGetPaginatedJobLogs = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedJobLogs>>, TError,GetPaginatedJobLogsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPaginatedJobLogs>>,
        TError,
        GetPaginatedJobLogsMutationVariables,
        TContext
      > => {
      return useMutation(getGetPaginatedJobLogsMutationOptions(options), queryClient);
    }
    export const getGetLogsByExecutionIdUrl = (params: GetLogsByExecutionIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Log/GetLogsByExecutionId?${stringifiedParams}` : `/api/Log/GetLogsByExecutionId`
}

export const getLogsByExecutionId = async (params: GetLogsByExecutionIdParams, options?: Parameters<typeof customInstance>[1]): Promise<LogDto[]> => {

  return customInstance<LogDto[]>(getGetLogsByExecutionIdUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLogsByExecutionIdQueryKey = (params?: GetLogsByExecutionIdParams,) => {
    return [
    `/api/Log/GetLogsByExecutionId`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLogsByExecutionIdQueryOptions = <TData = Awaited<ReturnType<typeof getLogsByExecutionId>>, TError = ErrorType<unknown>>(params: GetLogsByExecutionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogsByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLogsByExecutionIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLogsByExecutionId>>> = ({ signal }) => getLogsByExecutionId(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLogsByExecutionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLogsByExecutionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLogsByExecutionId>>>
export type GetLogsByExecutionIdQueryError = ErrorType<unknown>


export function useGetLogsByExecutionId<TData = Awaited<ReturnType<typeof getLogsByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetLogsByExecutionIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogsByExecutionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLogsByExecutionId>>,
          TError,
          Awaited<ReturnType<typeof getLogsByExecutionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLogsByExecutionId<TData = Awaited<ReturnType<typeof getLogsByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetLogsByExecutionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogsByExecutionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLogsByExecutionId>>,
          TError,
          Awaited<ReturnType<typeof getLogsByExecutionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLogsByExecutionId<TData = Awaited<ReturnType<typeof getLogsByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetLogsByExecutionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogsByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLogsByExecutionId<TData = Awaited<ReturnType<typeof getLogsByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetLogsByExecutionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogsByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLogsByExecutionIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetLogsByExecutionIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getLogsByExecutionId>>, TError = ErrorType<unknown>>(params: GetLogsByExecutionIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLogsByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLogsByExecutionIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLogsByExecutionId>>> = ({ signal }) => getLogsByExecutionId(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLogsByExecutionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetLogsByExecutionIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLogsByExecutionId>>>
export type GetLogsByExecutionIdSuspenseQueryError = ErrorType<unknown>


export function useGetLogsByExecutionIdSuspense<TData = Awaited<ReturnType<typeof getLogsByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetLogsByExecutionIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLogsByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLogsByExecutionIdSuspense<TData = Awaited<ReturnType<typeof getLogsByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetLogsByExecutionIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLogsByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLogsByExecutionIdSuspense<TData = Awaited<ReturnType<typeof getLogsByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetLogsByExecutionIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLogsByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLogsByExecutionIdSuspense<TData = Awaited<ReturnType<typeof getLogsByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetLogsByExecutionIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLogsByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLogsByExecutionIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetJobLogByExecutionIdUrl = (params: GetJobLogByExecutionIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Log/GetJobLogByExecutionId?${stringifiedParams}` : `/api/Log/GetJobLogByExecutionId`
}

export const getJobLogByExecutionId = async (params: GetJobLogByExecutionIdParams, options?: Parameters<typeof customInstance>[1]): Promise<JobLogDto> => {

  return customInstance<JobLogDto>(getGetJobLogByExecutionIdUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobLogByExecutionIdQueryKey = (params?: GetJobLogByExecutionIdParams,) => {
    return [
    `/api/Log/GetJobLogByExecutionId`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetJobLogByExecutionIdQueryOptions = <TData = Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError = ErrorType<unknown>>(params: GetJobLogByExecutionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobLogByExecutionIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobLogByExecutionId>>> = ({ signal }) => getJobLogByExecutionId(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobLogByExecutionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getJobLogByExecutionId>>>
export type GetJobLogByExecutionIdQueryError = ErrorType<unknown>


export function useGetJobLogByExecutionId<TData = Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetJobLogByExecutionIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobLogByExecutionId>>,
          TError,
          Awaited<ReturnType<typeof getJobLogByExecutionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobLogByExecutionId<TData = Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetJobLogByExecutionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobLogByExecutionId>>,
          TError,
          Awaited<ReturnType<typeof getJobLogByExecutionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobLogByExecutionId<TData = Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetJobLogByExecutionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetJobLogByExecutionId<TData = Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetJobLogByExecutionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobLogByExecutionIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetJobLogByExecutionIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError = ErrorType<unknown>>(params: GetJobLogByExecutionIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobLogByExecutionIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobLogByExecutionId>>> = ({ signal }) => getJobLogByExecutionId(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetJobLogByExecutionIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getJobLogByExecutionId>>>
export type GetJobLogByExecutionIdSuspenseQueryError = ErrorType<unknown>


export function useGetJobLogByExecutionIdSuspense<TData = Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetJobLogByExecutionIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobLogByExecutionIdSuspense<TData = Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetJobLogByExecutionIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobLogByExecutionIdSuspense<TData = Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetJobLogByExecutionIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetJobLogByExecutionIdSuspense<TData = Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError = ErrorType<unknown>>(
 params: GetJobLogByExecutionIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJobLogByExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobLogByExecutionIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






